import { createValidator, rules } from "@lchemy/model/validation";

export interface FindUserByEmailCmd {
  email: string;
}

export const findUserByEmailCmdValidator = createValidator<FindUserByEmailCmd>({
  email: [rules.required(), rules.isString(), rules.isEmail()]
});
